module.exports = __webpack_public_path__ + "img/header-engagementRingsRedgold.86362e1.webp";